import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { useEffect } from "react";
import { userEventModel } from "@/lib/event-tracking/values/models";
import type { User } from "@/types";

export const PostHogEventTrackingProvider = ({
  user,
}: {
  user: User | null;
}) => {
  const initializePostHog = () => {
    posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
      api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
      defaults: import.meta.env.VITE_PUBLIC_POSTHOG_DEFAULT_DATE,
    });
  };

  // Don't initialize when already initialized
  if (!posthog.__loaded) {
    initializePostHog();
  }

  useEffect(() => {
    if (user) {
      posthog?.identify(user.external_identifier, userEventModel(user));
    }
  }, [user]);

  return <PostHogProvider client={posthog} />;
};
